import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api } from "../../lib/api";

const opts = { withCredentials: true };

export const LaunchOfferSettings = () => {
  const [s, setS] = useState(null);
  useEffect(() => { api.get("/launch-offer").then((r) => setS(r.data)).catch(() => {}); }, []);
  if (!s) return null;
  const save = () => api.put("/admin/launch-offer", { ...s, percent: Number(s.percent) }, opts).then(() => toast.success("Offre de lancement enregistrée")).catch(() => toast.error("Pourcentage entre 1 et 90"));
  return (
    <div data-testid="launch-offer-settings" className="border border-[#9E4735]/40 bg-[#9E4735]/5 p-5 mb-8 font-body text-sm flex flex-wrap items-end gap-4">
      <div className="basis-full">
        <p className="text-[10px] tracking-[0.25em] uppercase text-[#9E4735]">Offre de lancement</p>
        <p className="text-xs text-[#4A4A4A] mt-1">Le lecteur qui termine un extrait obtient la version numérique à prix réduit pendant 48 h (prix barré + compte à rebours), puis le prix normal revient automatiquement.</p>
      </div>
      <label className="flex items-center gap-2"><input type="checkbox" checked={s.enabled} onChange={(e) => setS({ ...s, enabled: e.target.checked })} data-testid="launch-offer-enabled" /> Activer</label>
      <label className="flex items-center gap-2">Réduction <input type="number" min={1} max={90} value={s.percent} onChange={(e) => setS({ ...s, percent: e.target.value })} data-testid="launch-offer-percent" className="w-20 bg-[#FAF9F6] border border-[#D1CFC7] px-2 py-1.5" /> %</label>
      <button onClick={save} data-testid="launch-offer-save" className="bg-[#2C402E] text-[#FAF9F6] px-4 py-2 text-xs">Enregistrer</button>
    </div>
  );
};
